/* global gapi */


import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {logo} from '../assets/img/logo-white.png';
import { withFormik, Form, Field } from 'formik';
import Yup from "yup";

const errStyle = {
    color: 'red',
    fontSize: '14'
};


/**
 *
 */

const fieldRows = [
    {name: 'row', fields: [
        {name: 'name', type: 'text', placeholder: 'First Name'},
        {name: 'lname', type: 'text', placeholder: 'Last Name'}
        ]
    },
    {name: 'row', fields: [
        {name: 'email', type: 'email', placeholder: 'Email'},
        {name: 'courseRegistration', type: 'select', placeholder: 'Choose Course'}
        ]   
    },
    {name: 'row', fields: [
        {name: 'password', type: 'password', placeholder: 'Password'},
        {name: 'passwordAgain', type: 'password', placeholder: 'Password (Again)'}
    ]}
    
]

class Signup extends Component {

    constructor(props){
        super(props);

        this.state = {
            email: '',
            password: '',
            passwordAgain: '',
            name: '',
            lname: '',
            socialPhoto: '',
            role: 'student',
            courseRegistration: '',
            socialAuth: false,
            showName: false,
            googleProfile: {},
            facebookProfile: {},
            errors: []
        };

    }

    componentDidMount(){
        this.props.authClear();
        this.props.getAllCourses();


    }

    registerUser(){

        let hasError = false;
        let {errors} = this.state;
        errors = [];
        if(this.state.password !== this.state.passwordAgain){
            errors.push("Passwords don't match");
            hasError = true;
        }

        if(this.state.password.length < 8){
            errors.push('Password must be at least 8 characters');
            hasError = true;
        }
        if(!hasError){
            this.props.onRegister(this.state.email, this.state.password, this.state.name, this.state.lname, this.state.role, this.state.image,
                this.state.googleProfile, this.state.facebookProfile, this.state.courseRegistration);
            if(this.state.role == 'student') {
                this.props.history.push('/dashboard');
            }else{
                this.props.history.push('/dashboard-admin');
            }
        }

        this.setState({errors});


        

    }



    render(){

        const {errorMessage, values, errors, touched} = this.props;
        const {email, password, name, lname, role, courseRegistration} = this.state;
        let ready = (email && password && role);

        
        if(role == "student"){
            ready = (email && password && role && courseRegistration);
        }

        return (
            <div className="user-login-signup-wrap">
        <div className="ulsw-left-wrap">
            <div className="ulsw-left">
                <div className="uslw-top">
                    <div className="logo-wrap">
                        <a href="#"><img src={logo} /></a>    
                    </div>
                </div>
                <div className="uslw-middle">
                    <p className="left-content-wrap-head">99point9</p>   
                    <p className="left-content-wrap-description">PERSONALISED LEARNING. GUARANTEED SCORES.</p>
                    <p className="left-content-wrap-details">Introducing: The world's first student-centric, personalised, and content-mastery-focused platform.</p>
                    <div className="button-wrap">
                        <a href="#">Get Started</a>
                    </div>
                </div>
                <div className="uslw-bottom">
                </div>
            </div>

        </div>
        <div className="ulsw-right-wrap">
            <div className="ulsw-right">
                <div className="uslw-box">
                    <div className="extra-top-right">
                        <div>
                            Already have an account?
                        </div>
                        <div>
                            <Link to="/login" className="btn btn-default">Login</Link>
                        </div>
                    </div>
                    <h1>Sign in to 99point9</h1>
                    <h2>Enter your details below.</h2>
     
                    <Form onSubmit={this.props.handleSubmit}>

                        {fieldRows.map((row, i) => {
                            return (
                                <div className="row" key={i}>
                                    {row.fields.map((f, fi) => {
                                        if(f.name === 'courseRegistration'){
                                            return (
                                                <div className="col-sm-6" key={fi}>
                                                    <div className="form-group">
                                                        <label>Choose Course</label>
                                                        <select name="courseRegistration"
                                                                    value={values.courseRegistration}
                                                                    className={"form-control"}
                                                                    onChange={(e) => {
                                                                        
                                                                        this.props.setFieldValue('courseRegistration', e.target.value);
                                                                    }}
                                                                    onBlur={this.props.handleBlur}
                                                                    >
                                                                <option value={''}>Select a course</option>
                                                                {(this.props.allCourses) &&
                                                                    this.props.allCourses.map((course, index) => {
                                                                        return (
                                                                            <option value={course.id} key={index}>{course.name}</option>
                                                                        )
                                                                    })
                                                                }             
                                                        
                                                        </select>
                                                        {this.props.touched[f.name] && this.props.errors[f.name] &&
                                                        <p className="text-danger">{this.props.errors[f.name]}</p>
                                                    }
                                                    </div>
                                                    
                                                </div>
                                            )
                                        }else{
                                            return (
                                                <div className="col-sm-6" key={fi}>
                                                    <div className="form-group">
                                                        <label>{f.placeholder}</label>
                                                        <input type={f.type} className="form-control" name={f.name} value={values[f.name]}
                                                                    onChange={({target: {value}}) => {
                                                                        
                                                                        this.props.setFieldValue(f.name, value);
                                                                    }}
                                                                    onBlur={this.props.handleBlur}
                                                                    required />
                                                                    {this.props.touched[f.name] && this.props.errors[f.name] &&
                                                        <p className="text-danger">{this.props.errors[f.name]}</p>
                                                    }
                                                    </div>
                                                    
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                            )
                            
                        })}
                        
            
                    
                    {
                                errorMessage &&
                                <span style={errStyle}>{errorMessage}</span>
                            }

                {
                                                this.state.errors &&
                                                <span className="text-danger">{this.state.errors.map((e, i) => {
                                                    return <p key={i}>{e}</p>
                                                })}</span>
                                            }
                    
                    <div className="form-group">
                        <button type="submit" className="btn btn-primary" >Sign Up</button>
                    </div>
                    </Form>

                </div>
            </div>
        </div>
    </div>    
        )
        
    }

}

const SignupForm = withFormik({
    mapPropsToValues: () => ({
        name: '',
        lname: '',
        email: '',
        courseRegistration: '',
        password: '',
        passwordAgain: ''
    }),
    validationSchema: Yup.object().shape({
        name: Yup.string().required('Required'),
        lname: Yup.string().required('Required'),
        email: Yup.string().email('This is not a valid email').required('Required'),
        courseRegistration: Yup.string().required('Required'),
        password: Yup.string().min(8, 'Passwords must be at least 8 characters').required('Required'),
        passwordAgain: Yup.string().min(8, 'Passwords must be at least 8 characters').test('password-match', 'Passwords do not match', function(value){
            const { password } = this.parent;
            return password === value;
          })
    }),
    handleSubmit: (values, {setSubmitting, props}) => {
        if(props.onRegister){
            props.onRegister(values.email.toLowerCase(), values.password, values.name, values.lname, 'student', '',
                {}, {}, values.courseRegistration);
                props.history.push('/dashboard');
        }
        
    }
})(Signup)

SignupForm.propTypes = {
    errorMessage: PropTypes.string,
    onRegister: PropTypes.func.isRequired
};


export default SignupForm;


// WEBPACK FOOTER //
// ./src/components/Signup.js